import IconItem from './icon_item';

export default class Save extends IconItem {
  constructor() {
    super('save', 'Ctrl+S');
  }
}
